import { ChangeDetectionStrategy, Component, Inject, Input, LOCALE_ID, OnInit, ViewEncapsulation } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

import { AutoSubOnDestroy, DeviceService, OpenAppService, PoolInfo, ToastService, ToastType } from '../../providers';
import { Language, MotesPaths, ServiceId } from '../../models';


@AutoSubOnDestroy()
@Component({
    selector: 'voucher-receipt',
    templateUrl: './voucher-receipt.component.html',
    styleUrls: ['./voucher-receipt.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default
})
export class VoucherReceiptComponent implements OnInit {

    @Input('poolInfo') set setPoolInfo(poolInfo: PoolInfo) {
        this.poolInfo = poolInfo;
        if(!this.poolInfo) return;
        const tourLang = this.locale as Language;
        this.shareLink = `${MotesPaths.MOTES_HOME}${MotesPaths.VOUCHER_RECEIPT_PAGE(this.poolInfo.key, tourLang)}`;
    }

    @Input() serviceId: ServiceId;
    /** Set false to hide instructions when all vouchers have been claimed */
    @Input() showIfClaimed: boolean = true;

    public poolInfo: PoolInfo;
    public shareLink: string;
    public imageLoaded: boolean = false;
    public downloadImgLoaded = { 'apple': false, 'google': false };
    public canOpenShareDialog: boolean = false;
    public isIos: boolean;
    public isMobile: boolean;

    // Expose to view
    public Language = Language;

    constructor(
        private deviceService: DeviceService,
        private clipboard: Clipboard,
        private toastService: ToastService,
        private openAppService: OpenAppService,
        @Inject(LOCALE_ID) public locale: string) {}

    ngOnInit(): void {
        this.isMobile = this.deviceService.isMobile();
        this.isIos = this.deviceService.isIos();

        // Detect if this browser and version supports the share dialog
        this.canOpenShareDialog = Boolean(navigator.share);
    }

    public async openShareDialog() {
        if(!this.canOpenShareDialog) {
            this.copyToClipboard(this.shareLink);
            return;
        }

        navigator.share({ title: `Voucher for ${this.poolInfo.tour.title}`, url: this.shareLink }).then(() => {}).catch((err) => {
            console.log('Open share dialog failed: ', err);
        });
    }

    public async copyToClipboard(text: string) {
        const copySuccess = this.clipboard.copy(text);
        if(copySuccess) this.toastService.addToast($localize`Copied to clipboard.`, ToastType.OK);
        else this.toastService.addToast($localize`Oh no. We couldn't copy to clipboard.`, ToastType.ERR);
    }

    public downloadAppClick(buttonClicked: 'apple' | 'google') {
        if(!this.serviceId) return;

        // If already in native app, open app store/google play
        if(this.serviceId == ServiceId.NATIVE_APP) {
            this.openAppService.openAppMarketplace();
            return;
        }
        // If in mobile browser, attempt open app or otherwise app store/google play
        if(this.isMobile) {
            const subDir = MotesPaths.APP_CLAIM_PAGE(this.poolInfo?.key);
            this.openAppService.openApp(subDir);
            return;
        }
        // If in desktop browser, open app store/google play in new tab
        if(buttonClicked == 'apple') this.openAppService.openAppStoreInWeb();
        else this.openAppService.openGooglePlayInWeb();
    }

}